import React, { useContext, useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaSearch, FaEdit } from 'react-icons/fa';
import bgimage from '../assets/images/hero-roti.jpg';
import { LocationContext } from '../context/LocationContext';

const HeroSection = () => {
    const { location, setIsLocationModalOpen } = useContext(LocationContext);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Simulate network-based loading with variable timing
        const networkDelay = Math.random() * 1000 + 500; // 500ms to 1.5s
        const timer = setTimeout(() => {
            setLoading(false);
        }, networkDelay);
        return () => clearTimeout(timer);
    }, []);

    // Short address: Prefer city, else first part of formatted address
    const shortAddress = location ? (location.address) : (location.city);

    if (loading) {
        return (
            <section
                id="home"
                className="overflow-hidden bg-theme2 bg-cover bg-center md:py-32 py-24 pb-32 md:pb-32 md:px-10 px-7 relative"
                style={{
                    backgroundImage: `url(${bgimage})`,
                }}
            >
                <div className="container mx-auto md:px-10 md:py-32">
                    <div className="grid grid-cols-1 lg:grid-cols-7 gap-8 items-center">
                        {/* Left content placeholder */}
                        <div className="lg:col-span-4 text-white animate-pulse">
                            {/* Title placeholder */}
                            <div className="space-y-3 mb-4">
                                <div className="h-8 md:h-12 bg-white bg-opacity-20 rounded w-full"></div>
                                <div className="h-8 md:h-12 bg-white bg-opacity-20 rounded w-4/5"></div>
                            </div>

                            {/* Subtitle placeholder */}
                            <div className="h-4 md:h-5 bg-white bg-opacity-20 rounded w-3/4 mb-8"></div>

                            {/* Search Inputs placeholder */}
                            <div className="grid grid-cols-1 md:grid-cols-3 md:gap-4 mt-8">
                                {/* Location Input placeholder */}
                                <div className="bg-white bg-opacity-90 rounded-full md:px-4 md:py-4 px-4 py-2 shadow-md md:col-span-1">
                                    <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-full"></div>
                                </div>

                                {/* Search Input placeholder */}
                                <div className="bg-white bg-opacity-90 rounded-full px-4 py-2 shadow-md md:col-span-2 mt-5 md:mt-0">
                                    <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-full"></div>
                                </div>
                            </div>
                        </div>

                        {/* Right Image placeholder */}
                        <div className="lg:col-span-3 hidden lg:flex justify-center"></div>
                    </div>
                </div>
            </section>
        );
    }
    return (
        <section
            id="home"
            className="overflow-hidden bg-theme2 bg-cover bg-center md:py-32 py-24 pb-32 md:pb-32 md:px-10 px-7 relative"
            style={{
                backgroundImage: `url(${bgimage})`,
            }}
        >
            <div className="container mx-auto md:px-10 md:py-32">
                <div className="grid grid-cols-1 lg:grid-cols-7 gap-8 items-center">
                    {/* Left content */}
                    <div className="lg:col-span-4 text-white">
                        <p className="text-2xl md:text-5xl font-bold">
                            Delicious Indian Breads Delivered Fast & Fresh!
                        </p>
                        <p className="pt-3 text-sm md:text-base">
                            Homestyle Rotis & Breads Delivered Daily Near You!
                        </p>

                        {/* Search Inputs */}
                        <div className="grid grid-cols-1 md:grid-cols-3 md:gap-4 mt-8">
                            {/* Location Input */}
                            <div className="bg-white rounded-full flex items-center md:px-4 md:py-4 px-4 py-2 shadow-md md:col-span-1">
                                <FaMapMarkerAlt className="text-theme2 mr-2" />
                                <span className="flex-1 pr-2 text-gray-600 text-sm overflow-hidden text-ellipsis whitespace-nowrap">
                                    {shortAddress}
                                </span>
                                <FaEdit className="text-theme2 cursor-pointer" onClick={() => setIsLocationModalOpen(true)} />
                            </div>

                            {/* Search Input */}
                            <div className="bg-white rounded-full flex items-center px-4 py-2 shadow-md md:col-span-2 mt-5 md:mt-0">
                                <FaSearch className="text-theme2 mr-2" />
                                <input
                                    type="text"
                                    placeholder="Search for Rotiey, Thepla"
                                    className="flex-1 outline-none text-gray-600"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Right Image */}
                    <div className="lg:col-span-3 hidden lg:flex justify-center"></div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;



// // src/components/HeroSection.jsx
// import React from "react";
// import { FaMapMarkerAlt, FaChevronDown, FaSearch } from "react-icons/fa";
// import bgimage from "../assets/images/hero-roti.jpg"; // background image

// const HeroSection = () => {
//     return (
//         <section
//             id="home"
//             className="overflow-hidden bg-cover bg-center md:py-32 py-24 pb-32 md:pb-32 md:px-10 px-7 relative"
//             style={{
//                 backgroundImage: `url(${bgimage})`,
//             }}
//         >
//             <div className="container mx-auto md:px-10 md:py-32">
//                 <div className="grid grid-cols-1 lg:grid-cols-7 gap-8 items-center">
//                     {/* Left content */}
//                     <div className="lg:col-span-4 text-white">
//                         <p className="text-2xl md:text-5xl font-bold">
//                             Delicious Indian Breads Delivered Fast & Fresh!
//                         </p>
//                         <p className="pt-2 text-sm md:text-base">
//                             Homestyle Rotis & Breads Delivered Daily Near You!
//                         </p>

//                         {/* Search Inputs */}
//                         <div className="grid grid-cols-1 md:grid-cols-3 md:gap-4 mt-8">
//                             {/* Location Input */}
//                             <div className="bg-white rounded-full flex items-center md:px-4 md:py-4 px-4 py-2 shadow-md md:col-span-1">
//                                 <FaMapMarkerAlt className="text-theme2 mr-2" />
//                                 <input
//                                     type="text"
//                                     placeholder="Location"
//                                     className="flex-1 outline-none w-full text-gray-600"
//                                 />
//                                 <FaChevronDown className="text-theme2" />
//                             </div>

//                             {/* Search Input */}
//                             <div className="bg-white rounded-full flex items-center px-4 py-2 shadow-md md:col-span-2 mt-5 md:mt-0">
//                                 <FaSearch className="text-theme2 mr-2" />
//                                 <input
//                                     type="text"
//                                     placeholder="Search for Rotiey, Thepla"
//                                     className="flex-1 outline-none text-gray-600"
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Right Image */}
//                     <div className="lg:col-span-3 hidden lg:flex justify-center">
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default HeroSection;
